import script from "./QuoteList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteList.vue?vue&type=script&setup=true&lang=js"

import "./QuoteList.vue?vue&type=style&index=0&id=6a5ab612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5ab612"]])

export default __exports__